import React from "react";
import ProjectDetail from "./ProjectDetail";

export default function SingleProject() {
  return <ProjectDetail />;
}
